/**
 * Pathless layout route for unauthenticated screens (login, register,
 * forgot/reset, 2FA verify/setup, workspace picker).
 *
 * The underscore prefix marks this as a TanStack Router "pathless
 * layout" — the segment does NOT appear in the URL but every child
 * file inherits this shell. So `_auth/login.tsx` is reachable at
 * `/login`, `_auth/register.tsx` at `/register`, etc.
 *
 * Visual style mirrors the Next.js `frontend/src/app/(auth)/layout.tsx`:
 * a centred card on a tinted background, responsive down to 360px, with
 * the wordmark on top and a tagline below. The shell deliberately makes
 * NO auth decisions — that lives in the individual auth pages (e.g.
 * login routes the user post-login) and in `_dashboard.tsx` (which
 * bounces unauthenticated traffic INTO this layout via /login).
 */

import { Link, Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth")({
  component: AuthLayout,
});

function AuthLayout() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-4 py-10">
      <div className="w-full max-w-md">
        <Link
          to="/"
          className="mb-8 flex items-center justify-center gap-2"
          aria-label="WorkRight home"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary text-base font-bold text-primary-foreground">
            W
          </span>
          <span className="text-xl font-semibold tracking-tight text-gray-900">
            WorkRight
          </span>
        </Link>
        <Outlet />
        <p className="mt-8 text-center text-xs text-muted-foreground">
          HR &amp; compliance for Indian companies.
        </p>
      </div>
    </div>
  );
}
